import { getStorage, ref, deleteObject } from "firebase/storage";

const storage = getStorage();

export async function deleteFromStorage(path) {
  return new Promise(function (resolve, reject) {
    // Create a reference to the file to delete
    const desertRef = ref(storage, path);

    // Delete the file
    deleteObject(desertRef)
      .then(() => {
        // File deleted successfully
        resolve();
      })
      .catch((error) => {
        // Uh-oh, an error occurred!
        console.log(error);
      });
  });
}
